
import axios from 'axios';

// Configurează base URL pentru API
const API_URL = process.env.REACT_APP_API_URL || '';

axios.defaults.baseURL = API_URL;

export default axios;
